var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-logo"},[_c('router-link',{staticStyle:{"width":"100%"},attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.appLogo,"alt":"site logo","width":"160","height":"86"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }